'use client';

import { Calendar } from 'lucide-react';
import type { DateField } from './types';

interface DateValue {
  label: string;
  value: string | null | undefined;
}

interface DatesSectionProps {
  dates: DateValue[];
}

function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export function DatesSection({ dates }: DatesSectionProps) {
  const validDates = dates.filter(d => d.value);

  if (validDates.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 p-2 rounded-lg bg-card border border-border">
      <Calendar className="h-3 w-3 text-muted-foreground shrink-0" />
      <div className="flex items-center gap-2 text-xs overflow-x-auto">
        {validDates.map((date, idx) => (
          <div key={date.label} className="flex items-center gap-1 whitespace-nowrap">
            {idx > 0 && <span className="text-muted-foreground mx-1">→</span>}
            <span className="text-muted-foreground text-[10px]">{date.label}:</span>
            <span className="font-medium">{formatDate(date.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
